var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.777 24.144H2.28c.498-2.872 3.181-5.072 6.406-5.072 1.068 0 2.125.246 3.059.711.505.253 1.134.076 1.404-.394.271-.47.081-1.055-.424-1.307a9.088 9.088 0 0 0-4.039-.941c-4.722 0-8.564 3.574-8.564 7.968 0 .533.464.965 1.038.965h7.619c.573 0 1.037-.432 1.037-.965 0-.533-.464-.965-1.038-.965zM8.685 15.21c2.862 0 5.19-2.166 5.19-4.829s-2.328-4.829-5.19-4.829c-2.862 0-5.19 2.166-5.19 4.829s2.328 4.83 5.19 4.83zm0-7.727c1.718 0 3.115 1.3 3.115 2.898s-1.397 2.899-3.115 2.899c-1.718 0-3.115-1.3-3.115-2.899 0-1.598 1.397-2.898 3.115-2.898zM22.826 15.56c3.685 0 6.683-2.79 6.683-6.218 0-3.429-2.998-6.218-6.683-6.218-3.685 0-6.683 2.79-6.683 6.218s2.998 6.217 6.683 6.217zm0-10.505c2.54 0 4.608 1.923 4.608 4.287s-2.067 4.287-4.608 4.287c-2.54 0-4.607-1.923-4.607-4.287s2.066-4.287 4.607-4.287zM22.826 17.49c-6.214 0-11.27 4.703-11.27 10.485 0 .533.465.965 1.038.965h20.464c.573 0 1.037-.432 1.037-.965 0-5.782-5.055-10.485-11.269-10.485zm-9.136 9.52c.517-4.265 4.417-7.59 9.136-7.59 4.72 0 8.62 3.325 9.136 7.59H13.69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.bf595bb69071b2d41c7b7d380b14c067.svg";
export { ForwardRef as ReactComponent };